import axios from "axios";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";

function ExperienceDetail({ onSuccess }) {
  const location = useLocation();
  const navigate = useNavigate();

  const total_year_of_experience = location.state?.total_year_of_experience;
  const token = localStorage.getItem("authToken");
  const isOtherExperience = location.state?.isOtherExperience;

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const signupStatus = user.signup_complete_status; // 👈 get signupstatus from localStorage user

  const experienceId = location.state?.experienceId;

  const [categories, setCategories] = useState([]); // all categories from API
  const [subCategories, setSubCategories] = useState([]); // sub-categories for selected category
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [experienceIdhost, setExperienceIdhost] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [currency, setCurrency] = useState({
    id: 6,
    country_name: "Australia",
    currency: "AUD",
    symbol: "$",
  });

  const [imageLoading, setImageLoading] = useState([]);

  // 🔹 Address state
  const [address, setAddress] = useState({
    country_id: "",
    city_id: "",
    pin_code: "",
    locality: "",
    house_no: "",
  });
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  // Images state
  const [images, setImages] = useState([{ file: null, priority: "" }]);
  const imageFileRefs = useRef([]);
  const imagePriorityRefs = useRef([]);

  const updateexperienceId = location.state?.experienceId;

  const categoryRef = useRef();
  const subCategoryRef = useRef();
  const experienceYearRef = useRef();
  const titleRef = useRef();
  const shortDescRef = useRef();
  const aboutMeRef = useRef();

  const [experienceData, setExperienceData] = useState({
    title: "",
    about_me: "",
    short_description: "",
    total_year_of_experience: "",
  });

  useEffect(() => {
    // First check location.state
    if (location.state?.categoryId && location.state?.subCategoryId) {
      setCategoryId(location.state.categoryId);
      setSubCategoryId(location.state.subCategoryId);
    } else {
      // Otherwise, fallback to hostData from localStorage
      const hostData = localStorage.getItem("hostData");
      if (hostData) {
        try {
          const parsed = JSON.parse(hostData);
          setCategoryId(parsed.categoryId);
          setSubCategoryId(parsed.subCategoryId);
        } catch (e) {
          console.error("Error parsing hostData:", e);
        }
      }
    }
  }, [location.state]);

  // Add image
  const addImage = () => {
    setImages([...images, { file: null, priority: "" }]);
  };

  // Remove image
  const removeImage = (index) => {
    const updated = [...images];
    updated.splice(index, 1);
    setImages(updated);
  };

  useEffect(() => {
    const loadHostImages = async () => {
      try {
        // let expId = experienceId || updateexperienceId;
        let savedExperienceId = localStorage.getItem("experience_id");
        let url = "";

        if (
          String(signupStatus) === "1" &&
          (experienceId || savedExperienceId)
        ) {
          const finalId = experienceId || savedExperienceId;
          url = `${process.env.REACT_APP_API_BASE}/host/get-host-images/${finalId}`;
        } else if (String(signupStatus) === "0") {
          url = `${process.env.REACT_APP_API_BASE}/host/get-host-images`;
        } else {
          return;
        }

        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const imgData = res.data?.data || [];
        const baseUrl = res.data?.base_url || "";

        setImages(
          imgData.map((img) => ({
            file: null,
            priority: img.priority || "",
            previewUrl: img.image ? `${baseUrl}${img.image}` : "",
            id: img.id,
          })),
        );
      } catch (err) {
        console.error("Error fetching host images:", err);
      }
    };

    loadHostImages();
  }, [token]);

  const handleImageChange = (index, field, value, e) => {
    const updatedImages = [...images];

    if (field === "file" && value) {
      // ✅ Start loader only for file selection
      const updatedLoading = [...imageLoading];
      while (updatedLoading.length <= index) updatedLoading.push(false);
      updatedLoading[index] = true;
      setImageLoading(updatedLoading);

      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      const maxSize = 2 * 1024 * 1024; // 2 MB

      // ✅ Type validation
      if (!allowedTypes.includes(value.type)) {
        toast.error("Only JPG, JPEG, and PNG files are allowed");
        e.target.value = null;
        updatedLoading[index] = false;
        setImageLoading([...updatedLoading]);
        return;
      }

      // ✅ Size validation
      if (value.size > maxSize) {
        toast.error("Image size must be ≤ 2MB");
        e.target.value = null;
        updatedLoading[index] = false;
        setImageLoading([...updatedLoading]);
        return;
      }

      // ✅ Generate preview
      const previewUrl = URL.createObjectURL(value);
      updatedImages[index] = {
        ...updatedImages[index],
        file: value,
        previewUrl,
      };

      // ✅ Hide loader after 0.5 sec
      setTimeout(() => {
        updatedLoading[index] = false;
        setImageLoading([...updatedLoading]);
      }, 500);
    }

    // ✅ For priority input, update instantly (no loader)
    else if (field === "priority") {
      updatedImages[index].priority = value;
    }

    setImages(updatedImages);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setExperienceData((prev) => ({ ...prev, [name]: value }));

    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};

    if (isOtherExperience) {
      if (!selectedCategory) {
        // newErrors.category = "Category is required";
        toast.error("Category is required");
        categoryRef.current.focus();
        return false;
      }
      if (!selectedSubCategory) {
        // newErrors.subCategory = "Sub-category is required";
        toast.error("Sub-category is required");
        subCategoryRef.current.focus();
        return false;
      }
      if (!experienceData.total_year_of_experience) {
        // newErrors.total_year_of_experience = "Years of experience is required";
        toast.error("Years of experience is required");
        experienceYearRef.current.focus();
        return false;
      }
    }

    if (!experienceData.title.trim()) {
      // newErrors.title = "Title is required";
      toast.error("Title is required");
      titleRef.current.focus();
      return false;
    }
    if (!experienceData.short_description.trim()) {
      toast.error("Short intro is required");
      shortDescRef.current.focus();
      return false;
    }
    if (!experienceData.about_me.trim()) {
      // newErrors.about_me = "Experience description is required";
      toast.error("Experience description is required");
      aboutMeRef.current.focus();
      return false;
    }

    // 2. Address validation
    if (!address.country_id) {
      toast.error("Please select a country");
      return false;
    }
    if (!address.city_id) {
      toast.error("Please select a city");
      return false;
    }
    if (!address.pin_code || address.pin_code.length < 4) {
      toast.error("Please enter a valid pincode");
      return false;
    }
    if (!address.locality.trim()) {
      toast.error("Please enter locality/street address");
      return false;
    }
    // if (!address.house_no.trim()) {
    //   toast.error("Please enter flat/house no");
    //   return false;
    // }

    // Validate at least 1 image
    for (let i = 0; i < images.length; i++) {
      const img = images[i];
      // if (!img.file) {
      if (!img.file && !img.id && !img.previewUrl) {
        toast.error(`Image ${i + 1}: File is required`);
        imageFileRefs.current[i]?.focus();
        return false;
      }
      if (img.priority === "" || img.priority < 0) {
        toast.error(`Image ${i + 1}: Priority must be a positive number`);
        imagePriorityRefs.current[i]?.focus();
        return false;
      }
    }

    // ✅ Check for duplicate priorities
    const priorityValues = images.map((img) => String(img.priority).trim());

    const uniquePriorities = new Set(priorityValues);

    if (uniquePriorities.size !== priorityValues.length) {
      toast.error("Image priorities must be unique");
      return false;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ true if no errors
  };

  const handleNext = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; // ❌ stop if validation fails

    setLoading(true);
    const finalCategoryId = isOtherExperience ? selectedCategory : categoryId;
    const finalSubCategoryId = isOtherExperience
      ? selectedSubCategory
      : subCategoryId;
    const finalTotalYear = isOtherExperience
      ? experienceData.total_year_of_experience
      : total_year_of_experience;

    try {
      // 1️⃣ Save experience
      const experiencePayload = {
        category_id: finalCategoryId,
        sub_category_id: finalSubCategoryId,
        total_year_of_experience: finalTotalYear,
        title: experienceData.title,
        experience_id: experienceId || experienceIdhost,
        about_my_experience: experienceData.about_me,
        short_description: experienceData.short_description,
      };

      const expRes = await axios.post(
        `${process.env.REACT_APP_API_BASE}/host/add-experience`,
        experiencePayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const newExperienceId = expRes.data?.data?.id;
      if (!newExperienceId) throw new Error("Experience ID not returned");

      localStorage.setItem("experience_id", newExperienceId);
      setExperienceIdhost(newExperienceId);

      // 2️⃣ Save address
      const addressPayload = {
        experience_id: newExperienceId,
        ...address,
      };

      await axios.post(
        `${process.env.REACT_APP_API_BASE}/host/add-experience-address`,
        addressPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // 3️⃣ Upload images
      const formData = new FormData();
      images.forEach((img) => {
        if (img.file) {
          formData.append("images[]", img.file);
        } else if (img.id || img.previewUrl) {
          formData.append("old_image_ids[]", img.id);
        }
      });
      images.forEach((img, idx) => {
        formData.append("priorities[]", img.priority || idx);
      });
      formData.append("experience_id", newExperienceId);

      await axios.post(
        `${process.env.REACT_APP_API_BASE}/host/add-host-images`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      toast.success("Experience saved successfully ✅");
      if (onSuccess) onSuccess(newExperienceId); // pass the experience ID to parent
    } catch (err) {
      console.error("Error in handleNext:", err);
      const errMsg =
        err.response?.data?.message ||
        "Something went wrong while Sending OTP.";
      toast.error(errMsg);
      // toast.error(err.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetch categories on mount
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/get-category`,
        );
        setCategories(res.data?.data || []);
      } catch (err) {
        console.error("Error fetching categories", err);
      }
    };
    fetchCategories();
  }, []);

  const handleCategoryChange = async (e) => {
    const categoryId = e.target.value;
    setSelectedCategory(categoryId);
    setSelectedSubCategory("");

    // fetch subcategories for selected category
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/get-sub-category`,
        {
          category_id: categoryId, // ✅ dynamic id
        },
        // `${process.env.REACT_APP_API_BASE}/subcategories/${categoryId}`
      );
      setSubCategories(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching subcategories", err);
    }
  };

  // if signupstatus is 0 then call this api
  useEffect(() => {
    const fetchExistingExperience = async () => {
      try {
        let savedExperienceId = localStorage.getItem("experience_id");
        let url;

        if (
          String(signupStatus) === "1" &&
          (experienceId || savedExperienceId)
        ) {
          const finalId = experienceId || savedExperienceId;
          url = `${process.env.REACT_APP_API_BASE}/host/get-host-experience/${finalId}`;
        } else if (String(signupStatus) === "0") {
          url = `${process.env.REACT_APP_API_BASE}/host/get-host-experience`;
        } else {
          console.warn(
            "⚠️ No valid signupStatus or experience ID found, using fallback address.",
          );
          const storedAddress = JSON.parse(localStorage.getItem("user"));
          if (storedAddress) {
            setAddress(storedAddress);
          }
          return; // ✅ Now you can safely return *after* fallback
        }

        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = res.data?.data;
        if (!data) return;

        // ✅ Prefill experience fields
        setExperienceData({
          title: data.title || "",
          about_me: data.about_my_experience || "",
          short_description: data.short_description || "",
          total_year_of_experience: data.total_year_of_experience || "",
        });

        // ✅ Save experience_id for reuse
        setExperienceIdhost(data.id);

        // ✅ Currency setup
        if (data.currency_id && data.currency_symbol) {
          const apiCurrency = {
            id: data.currency_id,
            country_name: data.currency_name,
            currency: data.currency,
            symbol: data.currency_symbol,
          };
          setCurrency(apiCurrency);
          localStorage.setItem("selectedCurrency", JSON.stringify(apiCurrency));
        } else {
          const storedCurrency = JSON.parse(
            localStorage.getItem("selectedCurrency"),
          );
          setCurrency(
            storedCurrency || {
              id: 6,
              country_name: "Australia",
              currency: "AUD",
              symbol: "$",
            },
          );
        }

        // ✅ Prefill address here (instead of fetchExistingAddress)
        setAddress({
          country_id: data.country_id || "",
          city_id: data.city_id || "",
          pin_code: data.pin_code || "",
          locality: data.locality || "",
          house_no: data.house_no || "",
        });

        // ✅ Prefill categories if applicable
        if (String(signupStatus) === "1" && data.category_id) {
          const catRes = await axios.get(
            `${process.env.REACT_APP_API_BASE}/get-category`,
          );
          setCategories(catRes.data?.data || []);

          setSelectedCategory(data.category_id);

          const subRes = await axios.post(
            `${process.env.REACT_APP_API_BASE}/get-sub-category`,
            { category_id: data.category_id },
          );
          setSubCategories(subRes.data?.data || []);

          if (data.sub_category_id)
            setSelectedSubCategory(data.sub_category_id);
        }
      } catch (error) {
        console.error("Error fetching experience:", error);
        const storedAddress = JSON.parse(localStorage.getItem("user"));
        if (storedAddress) {
          setAddress(storedAddress);
        }
      }
    };

    fetchExistingExperience();
  }, [token]);

  // Fetch countries
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE}/getCountries`)
      .then((res) => setCountries(res.data.data || []))
      .catch(() => setCountries([]));
  }, []);

  // Fetch cities when country changes
  useEffect(() => {
    if (address.country_id) {
      axios
        .get(
          `${process.env.REACT_APP_API_BASE}/get-city-by-country/${address.country_id}`,
        )
        .then((res) => setCities(res.data.data || []))
        .catch(() => setCities([]));
    }
  }, [address.country_id]);

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };

  // 🔹 Fetch countries on mount
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE}/getCountries`)
      .then((res) => {
        setCountries(res.data.data || []); // adjust key based on API
      })
      .catch((err) => {
        console.error("Failed to load countries", err);
        setCountries([]); // fallback to empty array
      });
  }, []);

  // 🔹 Fetch cities when country changes
  useEffect(() => {
    if (address.country_id) {
      axios
        .get(
          `${process.env.REACT_APP_API_BASE}/get-city-by-country/${address.country_id}`,
        )
        .then((res) => {
          setCities(res.data.data || []); // 🔹 make sure it's always an array
        })
        .catch((err) => {
          console.error("Failed to load cities", err);
          setCities([]); // fallback
        });
    }
  }, [address.country_id]);

  return (
    <div className="frm_suport_als">
      {/* {loading && (
  <div className="fullpage-loader">
    <div className="spinner"></div>
    <p>Submitting your experience...</p>
  </div>
)} */}
      <div className="titlsss form_al_fildss">
        {/* <h5>Add Intro</h5> */}
        <form onSubmit={handleNext}>
          {errorMessage && (
            <div
              className="alert alert-danger"
              style={{ color: "red", marginBottom: "10px" }}
            >
              {errorMessage}
            </div>
          )}
          {successMessage && (
            <div
              className="alert alert-success"
              style={{ color: "green", marginBottom: "10px" }}
            >
              {successMessage}
            </div>
          )}

          {isOtherExperience && (
            <>
              <h5>Category</h5>
              <div className="form-group">
                <label>Category</label>
                <select
                  ref={categoryRef}
                  className="form-control"
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                >
                  <option value="">Choose category</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.category} {/* 👈 use category not name */}
                    </option>
                  ))}
                </select>
                {errors.category && (
                  <small className="text-danger">{errors.category}</small>
                )}
              </div>

              <div className="form-group">
                <label>Sub-Category</label>
                <select
                  ref={subCategoryRef}
                  className="form-control"
                  value={selectedSubCategory}
                  onChange={(e) => setSelectedSubCategory(e.target.value)}
                >
                  <option value="">Choose sub-category</option>
                  {subCategories.map((sub) => (
                    <option key={sub.id} value={sub.id}>
                      {sub.subcategory}
                    </option>
                  ))}
                </select>
                {errors.subCategory && (
                  <small className="text-danger">{errors.subCategory}</small>
                )}
              </div>

              <div className="form-group">
                <label>Year of experience</label>
                <input
                  ref={experienceYearRef}
                  type="text"
                  className="form-control"
                  placeholder="Year of Experience you have"
                  name="total_year_of_experience"
                  value={experienceData.total_year_of_experience}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={2}
                  onChange={handleChange}
                />
                {errors.total_year_of_experience && (
                  <small className="text-danger">
                    {errors.total_year_of_experience}
                  </small>
                )}
              </div>
            </>
          )}

          <h5>Add Intro of your Experience</h5>
          <div className="form-group">
            <label>Give your experience a title</label>
            <input
              ref={titleRef}
              type="text"
              className="form-control"
              placeholder="Enter experience title"
              name="title"
              maxLength={80}
              value={experienceData.title}
              onChange={handleChange}
            />
            {errors.title && (
              <small className="text-danger">{errors.title}</small>
            )}
          </div>

          <div className="form-group">
            <label>Short intro</label>
            <textarea
              ref={shortDescRef}
              className="form-control"
              name="short_description"
              placeholder="Describe your experience"
              maxLength={200}
              rows="4"
              value={experienceData.short_description}
              onChange={handleChange}
            ></textarea>
            {errors.short_description && (
              <small className="text-danger">{errors.short_description}</small>
            )}
          </div>

          <div className="form-group">
            <label>Describe your experience</label>
            <textarea
              ref={aboutMeRef}
              className="form-control"
              name="about_me"
              placeholder="Describe your experience"
              rows="4"
              value={experienceData.about_me}
              maxLength={1000}
              onChange={handleChange}
            ></textarea>
            {errors.about_me && (
              <small className="text-danger">{errors.about_me}</small>
            )}
          </div>

          <div className="titlsss form_al_fildss mt-3">
            <h5>Where should guests meet you ?</h5>
            <div className="form-group">
              <label>Country/Region </label>
              {/* <select
                className="form-control"
                name="country_id"
                value={address.country_id}
                onChange={handleAddressChange}
              >
                <option value="">Choose country/Region</option>
                {Array.isArray(countries) &&
                  countries.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))}
              </select> */}
              <Select
                className="type_search"
                placeholder="Choose country"
                options={countries.map((c) => ({
                  value: c.id,
                  label: c.name,
                }))}
                value={
                  countries.find((c) => c.id == address.country_id)
                    ? {
                        value: address.country_id,
                        label: countries.find((c) => c.id == address.country_id)
                          ?.name,
                      }
                    : null
                }
                onChange={(selected) =>
                  setAddress((prev) => ({
                    ...prev,
                    country_id: selected?.value || "",
                    city_id: "",
                  }))
                }
                isSearchable
              />
            </div>

            <div className="form-group">
              <label>City/town</label>
              {/* <select
                className="form-control"
                name="city_id"
                value={address.city_id}
                onChange={handleAddressChange}
              >
                <option value="">Choose city</option>
                {Array.isArray(cities) &&
                  cities.map((ct) => (
                    <option key={ct.id} value={ct.id}>
                      {ct.name}
                    </option>
                  ))}
              </select> */}
              <Select
              className="type_search"
                placeholder="Choose city"
                options={cities.map((c) => ({
                  value: c.id,
                  label: c.name,
                }))}
                value={
                  cities.find((c) => c.id == address.city_id)
                    ? {
                        value: address.city_id,
                        label: cities.find((c) => c.id == address.city_id)
                          ?.name,
                      }
                    : null
                }
                onChange={(selected) =>
                  setAddress((prev) => ({
                    ...prev,
                    city_id: selected?.value || "",
                  }))
                }
                isSearchable
              />
            </div>

            <div className="form-group">
              <label>Pincode</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter pincode"
                name="pin_code"
                value={address.pin_code}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                maxLength={6}
                onChange={handleAddressChange}
              />
            </div>

            <div className="form-group">
              <label>Locality/street adress</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Locality/street adress"
                name="locality"
                value={address.locality}
                onChange={handleAddressChange}
              />
            </div>

            <div className="form-group">
              <label>Flat , house etc (Optional)</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter flat , house"
                name="house_no"
                value={address.house_no}
                onChange={handleAddressChange}
              />
            </div>
          </div>

          <div className="titlsss form_al_fildss">
            <div className="ar_bothss">
              <h5>Add more photos of the experience</h5>

              <button
                type="button"
                className="al_sp_btn_blk"
                onClick={addImage}
              >
                <img alt="" src="/images/pls_adss.png" />
              </button>
            </div>

            {images.map((img, index) => (
              <div className="form-group" key={index}>
                <label>
                  Photo <span className="read_tx">*</span>
                </label>
                <div className="bothads">
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) =>
                      handleImageChange(index, "file", e.target.files[0], e)
                    }
                    ref={(el) => (imageFileRefs.current[index] = el)}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Add priority"
                    value={img.priority}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) =>
                      handleImageChange(index, "priority", e.target.value)
                    }
                    ref={(el) => (imagePriorityRefs.current[index] = el)}
                    maxLength={2}
                  />

                  {images.length > 1 && (
                    <span
                      className="btnss remove"
                      onClick={() => removeImage(index)}
                    >
                      <img alt="" src="/images/delates.png" />
                    </span>
                  )}
                </div>

                {imageLoading[index] && <div className="loader"></div>}
                {img.previewUrl && (
                  <div className="add_mgs_area">
                    <img src={img.previewUrl} alt="preview" />
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* <h5>Packages</h5>
				<div className="form-group">
					<label>Do you want to add package to your experience</label>
					<select
                className="form-control"
                name="country_id"
                value={address.country_id}
                onChange={handleAddressChange}
              >
                <option value="1">yes</option>
                 <option value="2">No</option>
                </select>
             {errors.title && <small className="text-danger">{errors.title}</small>}
				</div> */}

          <div className={`form-group ${!isOtherExperience ? "both" : ""}`}>
            {!isOtherExperience && (
              <button
                type="button"
                className="btn_allls over"
                onClick={() => navigate("/host-choose-experience")}
              >
                Back
              </button>
            )}
            <button type="submit" className="btn_allls" disabled={loading}>
              {/* {loading ? "Saving..." : "Next"} */}
              {loading ? (
                <>
                  <span className="spinner"></span>
                </>
              ) : (
                "Next"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ExperienceDetail;
